import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {UserStateProvider} from "../../providers/user-state/user-state";
import {ApiInitProvider} from "../../providers/api-init/api-init";
import {InitWizardProvider} from "../../providers/init-wizard/init-wizard";
import {ApiProvider} from "../../providers/api/api";

/**
 * Generated class for the AppMoodTrackerPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-mood-tracker',
  templateUrl: 'app-mood-tracker.html',
})
export class AppMoodTrackerPage {

  moodTracking: boolean;
  weightTracking: boolean;
  stepTracking: boolean;
  foodTracking: boolean;

  constructor(public navCtrl: NavController, public navParams: NavParams, public userState: UserStateProvider, public api: ApiProvider) {
  }

  ionViewDidLoad() {
    this.moodTracking = this.userState.user.program.moodTracking
    this.stepTracking = this.userState.user.program.stepTracking
    this.weightTracking = this.userState.user.program.weightTracking
    this.foodTracking = this.userState.user.program.foodTracking
  }

  saveData() {
    var data = this.userState.user.program;
    data.moodTracking = this.moodTracking;
    data.stepTracking = this.stepTracking;
    data.weightTracking = this.weightTracking;
    data.foodTracking = this.foodTracking;
    this.api.callPut('/users/'+this.userState.user.id, {program: data}).subscribe((res:any) => {
      this.userState.user.program.moodTracking = this.moodTracking
      this.userState.user.program.stepTracking = this.stepTracking
      this.userState.user.program.weightTracking = this.weightTracking
      this.userState.user.program.foodTracking = this.foodTracking
      this.navCtrl.pop();
    })
  }

}



// WEBPACK FOOTER //
// ./src/pages/app-mood-tracker/app-mood-tracker.ts